"use strict";
/**
 * todo
 * review naming (consider removing "SiteAssets*" prefix)
 * review "any" types
 * review warnings
 * replace require with import
 * execute singlepage - siteRevision logic
 * force fallback option
 * lint rules same as site-assets
 * eventually create a site-assets-wix-integration module to keep the core clean -> put common implementations there (MetricsReporter, HttpClient?, etc)
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.siteAssetsClientBuilder = exports.SiteAssetsFallbackError = exports.SiteAssetsServerError = exports.UrlBuilderError = exports.InvalidServerResponse = exports.HttpClientFetchError = exports.UnexpectedHttpClientError = void 0;
var siteAssetsUrlBuilder_1 = require("./siteAssetsUrlBuilder");
var siteAssetsRequestHandler_1 = require("./siteAssetsRequestHandler");
var siteAssetsClientModuleExecutor_1 = require("./siteAssetsClientModuleExecutor");
var siteAssetsModuleResultExtractor_1 = require("./siteAssetsModuleResultExtractor");
var siteAssetsHttpClientAdapter_1 = require("./siteAssetsHttpClientAdapter");
var siteAssetsClientErrors_1 = require("./domain/siteAssetsClientErrors");
Object.defineProperty(exports, "HttpClientFetchError", { enumerable: true, get: function () { return siteAssetsClientErrors_1.HttpClientFetchError; } });
Object.defineProperty(exports, "InvalidServerResponse", { enumerable: true, get: function () { return siteAssetsClientErrors_1.InvalidServerResponse; } });
Object.defineProperty(exports, "SiteAssetsFallbackError", { enumerable: true, get: function () { return siteAssetsClientErrors_1.SiteAssetsFallbackError; } });
Object.defineProperty(exports, "SiteAssetsServerError", { enumerable: true, get: function () { return siteAssetsClientErrors_1.SiteAssetsServerError; } });
Object.defineProperty(exports, "UnexpectedHttpClientError", { enumerable: true, get: function () { return siteAssetsClientErrors_1.UnexpectedHttpClientError; } });
Object.defineProperty(exports, "UrlBuilderError", { enumerable: true, get: function () { return siteAssetsClientErrors_1.UrlBuilderError; } });
var siteAssetsModuleMetricsReporter_1 = require("./siteAssetsModuleMetricsReporter");
var siteAssetsServerHttpHandler_1 = require("./siteAssetsServerHttpHandler");
exports.siteAssetsClientBuilder = function (collaborators, config, siteModels) {
    var urlBuilder = siteAssetsUrlBuilder_1.UrlBuilder(siteModels, config.siteAssetsTopology.useStagingServer);
    var requestHandler = siteAssetsRequestHandler_1.RequestHandler(config, urlBuilder, siteAssetsClientModuleExecutor_1.ClientModuleExecutor(config, collaborators, siteModels, urlBuilder), siteAssetsModuleResultExtractor_1.ModuleResultExtractor(), function (moduleMetricsReporter) {
        return siteAssetsHttpClientAdapter_1.HttpClientAdapter(collaborators.httpClient, moduleMetricsReporter);
    }, function (module) {
        return siteAssetsModuleMetricsReporter_1.ModuleMetricsReporter(collaborators.metricsReporter, module);
    }, siteAssetsServerHttpHandler_1.SiteAssetsServerHttpHandlerBuilder(siteAssetsServerHttpHandler_1.SiteAssetsServerHttpResponseBuilder()));
    var execute = function (request) {
        return requestHandler(request).execute();
    };
    var getPublicUrl = function (request) {
        return urlBuilder.siteAssetsUrl(request, config.siteAssetsTopology.publicBaseDomain);
    };
    return {
        execute: execute,
        getPublicUrl: getPublicUrl
    };
};
